import React from 'react';
import { Label } from 'fw/components';
import { Col, Modal, FormGroup, Row, Button, Glyphicon, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { DatePicker } from 'fw/forms';
import * as API from 'modules/app/API';
import * as Notifications from 'fw/globals/Notifications';
import Moment from 'moment';
import Loading from 'layouts/public/loading/Loading'

class ChangeCertificationDatePopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,
            dirty: false,
            busy: false,
            disabledSave: true,
            approveDate: props.approveDate,
            expirationDate: props.expirationDate,
            expirationEnabled: false
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            approveDate: nextProps.approveDate,
            expirationDate: nextProps.expirationDate,
            visible: nextProps.visible
        });
    }

    close = (success) => {
        this.setState({
            visible: false,
        }, function () {
            this.props.onClose(success);
        });
    }

    renderIndicator = () => {
        if (this.state.dirty)
            return <Glyphicon glyph="pencil" className="pull-right" style={{ color: "red" }} />
        else
            return null;
    }

    handleExpirationModeChange = () => {
        var me = this;
        this.setState({
            expirationEnabled: !(me.state.expirationEnabled)
        });
    }

    dirt = () => {
        this.setState({
            dirty: true
        });
    }

    getBusy = () => {
        this.setState({
            busy: true
        });
    }

    onChange = (value) => {
        var date = Moment(value, ["D MMM YYYY", "DD MMM YYYY"], true);
        if (!date.isValid()) {
            this.setState({
                disabledSave: true,
                approveDate: value
            });
            return;
        }

        this.setState({
            disabledSave: false,
            approveDate: value,
            expirationDate: date.add(1, 'year')
        });
        this.dirt();
    };

    onExpirationDateChange = (value) => {
        var date = Moment(value, ["D MMM YYYY", "DD MMM YYYY"], true);
        if (!date.isValid()) {
            this.setState({
                disabledSave: true,
                expirationDate: value
            });
            return;
        }

        this.setState({
            disabledSave: false,
            expirationDate: value
        });

        this.dirt();
    }

    handleSave = () => {
        const rqChange = {
            approveDate: this.state.approveDate,
            expirationDate: this.state.expirationEnabled ? this.state.expirationDate : null,
            certificationId: this.props.certificationId,
        };

        // Spinner
        this.getBusy();

        API.Admin.post('/certification/changeCertificationDate', rqChange,
            {
                success: (sr) => {
                    Notifications.success(sr.message);
                    this.setState({
                        busy: false,
                        dirty: false
                    });
                    this.close(true);
                },
                error: (sr) => {
                    this.setState({
                        busy: false,
                        dirty: true
                    }, () => { Notifications.error(sr.error.errorMessage); });

                }
            });
    }

    render() {
        const expirationDateTooltip = (
            <Tooltip id='expirationDateTooltip'>
                <Row>
                    <Col md={12}>
                        Expiration Date will be updated automatically.
                    </Col>
                </Row>
            </Tooltip>
        );

        let me = this;
        return (
            <Modal show={this.state.visible} onHide={this.close}
                dialogClassName="modal-50w">
                <Modal.Header>
                    <h3 style={{ marginTop: "10px", marginBottom: "0px" }}>
                        Change Certification Date - Generate New Certificate
                        <br /><small>Changing the Certification Date will also change the Expiration Date.<br />Doing so will generate a new Certificate for the VOB within VOCS.</small>
                    </h3>
                </Modal.Header>
                <Modal.Body>
                    <React.Fragment>
                        {this.state.busy ?
                            <Loading />
                            :
                            <Row>
                                <Col md={12}>
                                    {this.props.approveDate == null || this.props.certificationId == null ?
                                        <React.Fragment>
                                            <Row>
                                                <Col md={12}>
                                                    <h5><em>This action cannot be performed</em></h5>
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                        :
                                        <React.Fragment>
                                            <Row>
                                                <Col md={1}>
                                                </Col>
                                                <Col md={10}>

                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={3}>
                                                </Col>
                                                <Col md={3}>
                                                    <FormGroup>
                                                        <Label htmlFor='approveDate' required>
                                                            Approved Date
                                                        </Label>
                                                        <DatePicker
                                                            required
                                                            placeholder="Approved Date"
                                                            managed={true}
                                                            value={this.state.approveDate}
                                                            onFieldChange={e => me.onChange(e)}
                                                            showTime={false}
                                                            disabled={this.state.busy}
                                                            className='dpThin'
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md={4}>
                                                    <FormGroup>
                                                        <Label>
                                                            Expiration Date
                                                            &nbsp;&nbsp;
                                                            <OverlayTrigger placement="right" overlay={expirationDateTooltip}>
                                                                <FontAwesomeIcon icon={faInfoCircle} size="1x" className="tooltipIcon" />
                                                            </OverlayTrigger>
                                                        </Label>
                                                        <Row>
                                                            <Col md={9}>
                                                                <DatePicker
                                                                    key={this.state.expirationEnabled}
                                                                    disabled={!this.state.expirationEnabled}
                                                                    placeholder="Expiration Date"
                                                                    managed={true}
                                                                    value={this.state.expirationDate}
                                                                    onFieldChange={e => me.onExpirationDateChange(e)}
                                                                    showTime={false}
                                                                    className='dpThin'
                                                                />
                                                            </Col>
                                                            <Col md={3}>
                                                                <Button id="btnEditExpiration"
                                                                    disabled={this.state.busy}
                                                                    onClick={this.handleExpirationModeChange}
                                                                    style={{ marginTop: "5px" }}>
                                                                    <Glyphicon glyph="pencil" />
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={2}>
                                                    <span className="pull-right">
                                                        {this.renderIndicator()}
                                                    </span>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={12}>
                                                    <br />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1}>
                                                </Col>
                                                <Col md={10}>
                                                    <div className="alert" style={{ textAlign: "center", color: "#721c24", backgroundColor: "#f8d7da", borderColor: "#f5c6cb" }}>
                                                        <strong>
                                                            <FontAwesomeIcon icon={faExclamationTriangle} size="1x" />
                                                            &nbsp;&nbsp;Attention! This action cannot be undone.
                                                        </strong>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    }
                                </Col>
                            </Row>
                        }
                    </React.Fragment>
                </Modal.Body>
                <Modal.Footer>
                    <Button id="btnSaveChanges" bsStyle="success"
                        disabled={!this.state.dirty || this.state.busy || this.state.disabledSave} onClick={this.handleSave}>Save Changes</Button>
                    <Button onClick={this.close} disabled={this.state.busy}>Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default ChangeCertificationDatePopUp;


// WEBPACK FOOTER //
// ./src/areas/admin/connectToVOB/ChangeCertificationDatePopUp.js